import { ShoppingCartOutlined, SettingOutlined, AppstoreOutlined, NotificationOutlined, BulbOutlined, TeamOutlined, PayCircleOutlined, LineChartOutlined } from '@ant-design/icons';

const menus = [
  {
    key: 'presales',
    icon: ShoppingCartOutlined,
    name: '销售',
    subMenu: [
      {
        name: '意向客户',
        path: '/presales/potential/index',
      },
      {
        name: '成交车辆',
        path: '/presales/deal/index',
      },
    ],
  }, {
    key: 'aftersales',
    icon: SettingOutlined,
    name: '售后',
    subMenu: [
      {
        name: '开单',
        path: 'group',
        items: [
          {
            name: '创建工单',
            path: '/aftersales/work-order/new',
            target: '_blank',
          }, {
            name: '配件销售',
            path: '/aftersales/part-sale/new',
            target: '_blank',
          }, {
            name: '耗材领用',
            path: '/aftersales/consumptive-material/index',
          },
        ],
      }, {
        name: '单据管理',
        path: 'group',
        items: [
          {
            name: '工单管理',
            path: '/aftersales/work-order/index',
          }, {
            name: '电池检测',
            path: '/aftersales/battery-check-report/index',
          }, {
            name: '企业工单',
            path: '/aftersales/enterprise-work-order/index',
          }, {
            name: '销售单管理',
            path: '/aftersales/part-sale/index',
          },
        ],
      }, {
        name: '客户',
        path: 'group',
        items: [
          {
            name: '车辆管理',
            path: '/aftersales/auto/index',
          }, {
            name: '车主管理',
            path: '/aftersales/auto-customer/index',
          }, {
            name: '会员管理',
            path: '/aftersales/member/index',
          }, {
            name: '客户评价',
            path: '/aftersales/customer/score',
          },
        ],
      }, {
        name: '项目',
        path: 'group',
        items: [
          {
            name: '项目管理',
            path: '/maintain-item/index',
          }],
      }, /* {
        name: '周报',
        path: 'group',
        items: [
          {
            name: '周报',
            path: '/weekly/new',
          },
        ],
      } */],
  }, {
    key: 'warehouse',
    icon: AppstoreOutlined,
    name: '仓库',
    subMenu: [
      {
        name: '开单',
        path: 'group',
        items: [
          {
            name: '采购开单',
            path: '/warehouse/purchase/new',
            target: '_blank',
          }, {
            name: '退货开单',
            path: '/warehouse/purchase-reject/new',
            target: '_blank',
          },
          // {
          //   name: '盘点开单',
          //   path: '/warehouse/stocktaking/new',
          //   target: '_blank',
          // },
        ],
      }, {
        name: '单据',
        path: 'group',
        items: [
          {
            name: '采购单管理',
            path: '/warehouse/purchase/index',
          }, {
            name: '退货单管理',
            path: '/warehouse/purchase-reject/index',
          }, {
            name: '盘点单管理',
            path: '/warehouse/stocktaking/index',
          },
        ],
      }, {
        name: '配件及其他',
        path: 'group',
        items: [
          {
            name: '配件管理',
            path: '/warehouse/part/index',
          }, {
            name: '库存预警',
            path: '/aftersales/inventory-warn/index',
          }, {
            name: '供应商管理',
            path: '/warehouse/supplier/index',
          }, {
            name: '出入库管理',
            path: '/warehouse/logs/index',
          }, {
            name: '分类及加价率',
            path: '/warehouse/markup-rate/index',
          },
        ],
      }],
  }, {
    key: 'dashboard',
    icon: LineChartOutlined,
    name: '报表',
    subMenu: [
      {
        name: '销售业务',
        path: '/dashboard/presales',
      }, {
        name: '售后业务',
        path: '/dashboard/aftersales',
      }],
  }, {
    key: 'finance',
    icon: PayCircleOutlined,
    name: '财务',
    subMenu: [
      {
        name: '资金管理',
        path: 'group',
        isPrivate: true,
        items: [
          {
            name: '收款管理',
            path: '/finance/receive-money-qrcode/income',
          }, {
            name: '提现管理',
            path: '/finance/receive-money-qrcode/withdraw',
          },
        ],
      }, {
        name: '业务收支',
        path: 'group',
        items: [
          {
            name: '收支管理',
            path: '/finance/expense/list',
          }, {
            name: '新车收入',
            path: '/finance/presales-income/list',
          }, {
            name: '财务月报',
            path: '/finance/monthly_report',
          },
        ],
      }, {
        name: '资产管理',
        path: 'group',
        items: [
          {
            name: '固定资产',
            path: '/finance/fixed-assets/index',
          },
        ],
      }],
  }, {
    key: 'personnel',
    icon: TeamOutlined,
    name: '人事',
    subMenu: [
      {
        name: '员工管理',
        path: '/personnel/user/list',
      }, {
        name: '提成管理',
        path: '/personnel/commission/list',
      }],
  }, {
    key: 'marketing',
    icon: BulbOutlined,
    name: '营销',
    subMenu: [
      {
        name: '优惠券',
        path: 'group',
        items: [
          {
            name: '优惠券管理',
            path: '/marketing/coupon/list',
          },
        ],
      }, {
        name: '套餐卡',
        path: 'group',
        items: [
          {
            name: '套餐卡管理',
            path: '/marketing/coupon-card/list',
          }, {
            name: '销售记录',
            path: '/marketing/coupon-card/orders',
          },
        ],
      }, {
        name: '工具',
        path: 'group',
        items: [
          {
            name: '领券活动',
            path: '/marketing/coupon-activity/list',
          },
          {
            name: '助力砍价',
            path: '/marketing/bargain/index',
          }, {
            name: '短信管理',
            key: 'sms',
            path: '/company/sms-manage',
          },
        ],
      }],
  }, {
    key: 'remind',
    icon: NotificationOutlined,
    name: '提醒',
    subMenu: [
      {
        name: '续保提醒',
        key: 'remind_renewal',
        path: '/remind/renewal',
      }, {
        name: '保养提醒',
        key: 'remind_maintain',
        path: '/remind/maintain',
      }, {
        name: '年检提醒',
        key: 'remind_yearly_inspection',
        path: '/remind/yearly-inspection',
      }, {
        name: '催收提醒',
        key: 'remind_debt',
        path: '/remind/debt',
      }, {
        name: '套餐卡到期',
        key: 'remind_coupon_card',
        path: '/remind/coupon-card',
      }, {
        name: '生日提醒',
        key: 'remind_birthday',
        path: '/remind/birthday',
      }, {
        name: '其他回访',
        key: 'remind_common',
        path: '/remind/common',
      }],
  }, {
    key: 'setting',
    icon: SettingOutlined,
    name: '设置',
    subMenu: [
      {
        name: '门店设置',
        key: 'store_settings',
        path: '/company-setting',
      },
    ],
  }];

export default menus;
